import { AppState } from './types';

export function isUpdated(state: AppState) {
  const { versionCode } = state.installed;
  const { versionCode: latest } = state.latest;
  return latest <= versionCode;
}

